import Swiper from "swiper/bundle";

var swiper = new Swiper(".dkKansa10Swiper", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        dragSize:
            window.innerWidth > 1024
                ? (513 / 1728) * innerWidth
                : (91 / 393) * innerWidth,
    },
});

if (window.innerWidth <= 1024) {
    var swiper = new Swiper(".mySwiper", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}
